import { useState } from "react";
import { Modal, SelectField } from "./AdministrationFields";
import { GUARDIAN_OPTIONS } from "../model/administrationConstants";
import { formatGuardianContactValue, normalizeGuardianContactStatus, parseGuardianContactValue } from "../model/administrationRules";
import { confirmDeleteButtonStyle, primaryButtonStyle, secondaryButtonStyle } from "../styles/administrationModalStyles";
import {
    guardianContactDeleteButtonStyle,
    guardianContactFieldStyle,
    guardianContactSummaryStyle,
    guardianContactSummaryWrapperStyle,
    inputStyle,
    labelStyle,
} from "../styles/administrationStyles";

export function GuardianContactModal({ contact, onClose, onSave }) {
    const [form, setForm] = useState(() => parseGuardianContactValue(contact));

    const submit = event => {
        event.preventDefault();
        onSave(formatGuardianContactValue(form));
    };

    return (
        <Modal title="Contact tuteur" onClose={onClose} width={520}>
            <form onSubmit={submit} style={{ display: "grid", gap: "14px" }}>
                <label style={labelStyle}>
                    <span>Nom</span>
                    <input
                        autoFocus
                        style={inputStyle}
                        value={form.nom}
                        onChange={event => setForm(current => ({ ...current, nom: event.target.value }))}
                    />
                </label>
                <label style={labelStyle}>
                    <span>Prénom</span>
                    <input
                        style={inputStyle}
                        value={form.prenom}
                        onChange={event => setForm(current => ({ ...current, prenom: event.target.value }))}
                    />
                </label>
                <label style={labelStyle}>
                    <span>Mail</span>
                    <input
                        type="email"
                        style={inputStyle}
                        value={form.mail}
                        onChange={event => setForm(current => ({ ...current, mail: event.target.value }))}
                    />
                </label>
                <label style={labelStyle}>
                    <span>Adresse</span>
                    <textarea
                        rows={3}
                        style={{ ...inputStyle, resize: "vertical" }}
                        value={form.adresse}
                        onChange={event => setForm(current => ({ ...current, adresse: event.target.value }))}
                    />
                </label>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <button type="button" onClick={onClose} style={secondaryButtonStyle}>Annuler</button>
                    <button type="submit" style={primaryButtonStyle}>Enregistrer</button>
                </div>
            </form>
        </Modal>
    );
}

export function GuardianContactField({ status, contact, onPatch }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [hovered, setHovered] = useState(false);
    const hasContact = Boolean(String(contact || "").trim());

    const saveContact = value => {
        onPatch({
            guardianContactValue: value,
        });
        setModalOpen(false);
    };

    const deleteContact = () => {
        onPatch({
            guardianContactStatus: "NONE",
            guardianContactValue: "",
        });
        setConfirmDeleteOpen(false);
    };

    return (
        <div style={guardianContactFieldStyle}>
            <SelectField
                value={normalizeGuardianContactStatus(status)}
                options={GUARDIAN_OPTIONS}
                onChange={value => onPatch({ guardianContactStatus: value })}
            />
            {hasContact ? (
                <div
                    style={guardianContactSummaryWrapperStyle}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    <pre style={guardianContactSummaryStyle}>{contact}</pre>
                    {hovered && (
                        <button
                            type="button"
                            aria-label="Supprimer le contact tuteur"
                            title="Supprimer le contact"
                            onClick={() => setConfirmDeleteOpen(true)}
                            style={guardianContactDeleteButtonStyle}
                        >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M3 6h18" />
                                <path d="M8 6V4h8v2" />
                                <path d="M19 6l-1 14H6L5 6" />
                                <path d="M10 11v5" />
                                <path d="M14 11v5" />
                            </svg>
                        </button>
                    )}
                </div>
            ) : (
                <span style={{ color: "#94a3b8", fontSize: "13px" }}>Aucun contact renseigné.</span>
            )}
            <button type="button" style={secondaryButtonStyle} onClick={() => setModalOpen(true)}>
                {hasContact ? "Modifier le contact" : "Ajouter un contact"}
            </button>
            {modalOpen && (
                <GuardianContactModal
                    contact={contact}
                    onClose={() => setModalOpen(false)}
                    onSave={saveContact}
                />
            )}
            {confirmDeleteOpen && (
                <Modal title="Supprimer le contact ?" onClose={() => setConfirmDeleteOpen(false)} width={460}>
                    <div style={{ display: "grid", gap: "18px" }}>
                        <p style={{ margin: 0, color: "#374151", lineHeight: 1.6 }}>
                            Confirmer la suppression des informations du contact tuteur ?
                        </p>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <button type="button" onClick={() => setConfirmDeleteOpen(false)} style={secondaryButtonStyle}>
                                Annuler
                            </button>
                            <button type="button" onClick={deleteContact} style={confirmDeleteButtonStyle}>
                                Valider
                            </button>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
}
